import { render, staticRenderFns } from "./purchase-change-modal.vue?vue&type=template&id=5a2178d8&scoped=true&"
import script from "./purchase-change-modal.vue?vue&type=script&lang=js&"
export * from "./purchase-change-modal.vue?vue&type=script&lang=js&"
import style0 from "./purchase-change-modal.vue?vue&type=style&index=0&id=5a2178d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2178d8",
  null
  
)

export default component.exports